import React, { Component } from 'react';
import './styles.css';

class Col extends Component {
	render() {
		return (
			<div className="three-years-table-layout-col">{this.props.children}</div>
		);
	}
}

export default Col;
